import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class EmailPasswordForm extends BaseModel {
  email = null;
  password = null;
  captcha = null;

  rules = {
    email: 'required',
    password: 'required',
    captcha: 'required',
  };

  attributeLabels = {
    email: i18n.t('Email'),
    password: i18n.t('Password')
  };

  constructor(email = '', password = '') {
    super();
    this.email = email;
    this.password = password;
    this.captcha = null;
  }
}
